export default ["col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ns-resize", "ew-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "nesw-resize", "nwse-resize"];
